import React from 'react';
import './privacyPage.scss';
import { withRouter } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import Hero from '../../components/hero/hero';
import Section from '../../components/section/section';
import { PADDING_ALL } from '../../utils/styleValues';

class PrivacyPage extends React.Component {
    render() {
        const { t } = this.props;
        return (
            <section className="page privacy-page">
                <Hero title={t('privacyPageTitle')} />

                <Section padding={PADDING_ALL} className="privacy-page--blurb">
                    <p>{t('pp:lastModified')}</p>
                    <div dangerouslySetInnerHTML={{ __html: t('pp:ppContent') }}></div>
                </Section>
            </section>
        );
    }
}
export default withTranslation('global')(withRouter(PrivacyPage));
